var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 relative"},[(_vm.center && _vm.center.lat && _vm.center.lng && _vm.startPosition.lat && _vm.startPosition.lng && _vm.endPosition.lat && _vm.endPosition.lng)?_c('GmapMap',{ref:"map",staticClass:"w-full h-full",attrs:{"center":_vm.center,"zoom":8,"options":{
      minZoom: 4,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
    }}},[_vm._l((_vm.rectangles),function(rect){return _c('GmapRectangle',{key:rect.id,attrs:{"bounds":rect.bounds,"editable":true,"draggable":true},on:{"bounds_changed":(val) => _vm.$emit('bounds-changed', val, rect.id)}})}),_c('GmapMarker',{attrs:{"position":_vm.startPosition},on:{"click":function($event){return _vm.$emit('update:center', _vm.startPosition)}}}),_vm._l((_vm.bridgesList),function(item,index){return _c('GmapMarker',{key:'bridge-' + index,attrs:{"icon":require('@/assets/marker/bridge.png'),"position":{ lat: item.startLat, lng: item.startLng },"label":{
        text: item.name,
        color: '#374151',
        className: 'marker-label-modern',
        fontSize: '10px',
      }}})}),_vm._l((_vm.customPoints),function(item,index){return _c('GmapMarker',{key:'customs-' + index,attrs:{"icon":require('@/assets/marker/customspoints.png'),"position":{
        lat: Number(item.latitude),
        lng: Number(item.longitude),
      },"label":{
        text: item.name + ' Sınır Kapısı',
        color: '#374151',
        className: 'marker-label-modern',
        fontSize: '10px',
      }}})}),_c('GmapPolyline',{attrs:{"path":_vm.polyLineList,"options":{
        strokeWidth: 20,
        strokeColor: '#C43A3A',
        editable: false,
        draggable: false
      }},on:{"update:path":function($event){_vm.polyLineList=$event}}}),_vm._l((_vm.filterWaypoints()),function(item,index){return _c('GmapMarker',{directives:[{name:"show",rawName:"v-show",value:(item.no),expression:"item.no"}],key:index,attrs:{"position":item,"label":{
        text: item.no + '. Teslim Noktası',
        color: '#374151',
        className: 'marker-label-modern',
        fontSize: '10px',
      },"icon":{
        url: _vm.locationPinImages[(item.no - 1) % 5],
        scaledSize: { width: 24, height: 24 },
      }}})}),(_vm.circleCenter)?_c('GmapCircle',{ref:"circleRef",attrs:{"center":_vm.circleCenter,"radius":50,"editable":false,"draggable":_vm.isDragging}}):_vm._e(),_vm._l((_vm.tollsList),function(item,index){return _c('div',{key:'toll-' + index},[(item.typeId === 1)?_c('GmapMarker',{attrs:{"position":{ lat: item.startLat, lng: item.startLng },"icon":require('@/assets/marker/hgs.png'),"label":{
          text: `Giriş : ${item.name}`,
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }},on:{"click":function($event){return _vm.$emit('update:center', { lat: item.startLat, lng: item.startLng })}}}):_vm._e(),(item.typeId === 1)?_c('GmapMarker',{attrs:{"position":{ lat: item.endLat, lng: item.endLng },"icon":require('@/assets/marker/hgs.png'),"label":{
          text: `Çıkış : ${item.name}`,
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }},on:{"click":function($event){return _vm.$emit('update:center', { lat: item.endLat, lng: item.endLng })}}}):_vm._e(),(item.typeName === 2)?_c('GmapMarker',{attrs:{"position":{ lat: item.startLat, lng: item.startLng },"icon":require('@/assets/marker/barrier.png'),"label":{
          text: item.name,
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }},on:{"click":function($event){return _vm.$emit('update:center', { lat: item.startLat, lng: item.startLng })}}}):_vm._e()],1)}),_c('GmapMarker',{attrs:{"position":_vm.endPosition,"icon":require('@/assets/marker/flag.png')},on:{"click":function($event){return _vm.$emit('update:center', _vm.endPosition)}}})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }